import { Task } from "./task-tracker.entities";

var Highcharts = require('highcharts/highcharts-gantt');

export class TaskTrackerGanttChart {

    chart: any;

    constructor() { }

    initialize(milestones: Task[], showStudyAreaPrefix: boolean): void {

        //console.log(milestones);

        let minDate: number = null;
        let maxDate: number = null;
        let startSpacerData: MilestoneDisplayData;
        let endSpacerData: MilestoneDisplayData;

        let chartHash: Map<string, MilestoneDisplayData> = new Map<string, MilestoneDisplayData>();
        let completionMap: Map<string, boolean> = new Map<string, boolean>();
        let taskCompletionMap: Map<string, boolean> = new Map<string, boolean>();
        let tempCategory = "";
        for (let i = 0; i < milestones.length; ++i) {
            let milestone = milestones[i];
            if (milestone.ActualStartDate != "" && milestone.ActualEndDate == "") {
                taskCompletionMap.set(milestone.Name, (milestone.ActualStartDate != "" && milestone.ActualEndDate == ""));
            }
            console.log(taskCompletionMap);
            if (showStudyAreaPrefix) {
                //milestone.Name = milestone.StudyArea + " - " + milestone.Name;
                milestone.GanttTaskCategory = milestone.StudyArea;
            }
            else { milestone.GanttTaskCategory = milestone.TaskCategory; }


            if (milestone.GanttTaskCategory != tempCategory && !completionMap.has(milestone.GanttTaskCategory)) {

                completionMap.set(milestone.GanttTaskCategory, true);
                tempCategory = milestone.GanttTaskCategory;
            }
            if (milestone.ActualEndDate == "" && (milestone.PlannedEndDate != "" || milestone.ActualStartDate != "")) {
                completionMap.set(milestone.GanttTaskCategory, false);
            }
        }

        let groupPrefix = "group-";

        for (let i = 0; i < milestones.length; ++i) {
            let milestone = milestones[i];
            
            //if (milestone.StartDate == "") milestone.DueDate = "2021-06-01";
            //if (milestone.DueDate == "") milestone.DueDate = "2022-08-31";

            //console.log(milestone.StartDate, milestone.DueDate, milestone.ActualStartDate, milestone.DeliveredDate);

            let categoryData: MilestoneDisplayData = chartHash.get(groupPrefix + milestone.GanttTaskCategory.toLowerCase());
            if (categoryData == null) {
                categoryData = new MilestoneDisplayData(milestone.GanttTaskCategory, "group", groupPrefix + milestone.GanttTaskCategory.toLowerCase(), null, null, null, (showStudyAreaPrefix) ? false : true);
                //categoryData = new MilestoneDisplayData(milestone.GanttTaskCategory, "group", milestone.SortOrder + "", null, null, (showStudyAreaPrefix) ? false : true);
                if (completionMap.get(milestone.GanttTaskCategory)) {
                    categoryData.setColorByStatus("Completed");
                }
                else {
                    categoryData.setColorByStatus("Not Started");
                }

                //the first category
                if (chartHash.size == 0) {
                    startSpacerData = new MilestoneDisplayData(milestone.GanttTaskCategory, "spacer", null, null, null, null, null);
                    endSpacerData = new MilestoneDisplayData(milestone.GanttTaskCategory, "spacer", null, null, null, null, null);
                }
            }

            categoryData.checkDates(this.getDate(milestone.PlannedEndDate), this.getDate(milestone.PlannedEndDate), this.getDate(milestone.ActualStartDate), (milestone.Status == "Completed") ? this.getDate(milestone.ActualEndDate) : (milestone.Status == "In Progress") ? this.today() : null);
            chartHash.set(groupPrefix + milestone.GanttTaskCategory.toLowerCase(), categoryData);

            //to set the bounds of the x-axis
            if (minDate == null || (categoryData.start != null && categoryData.start < minDate)) minDate = categoryData.start;
            if (maxDate == null || (categoryData.end != null && categoryData.end > maxDate)) maxDate = categoryData.end;

            let actualWork: MilestoneDisplayData = this.createActualWork(milestone, groupPrefix + milestone.GanttTaskCategory.toLowerCase(), this.today());
            //let plannedWork: MilestoneDisplayData = this.createPlannedWork(milestone, groupPrefix + milestone.GanttTaskCategory.toLowerCase());
            let actualMilestone: MilestoneDisplayData = this.createActualMilestone(milestone, groupPrefix + milestone.GanttTaskCategory.toLowerCase());
            let plannedMilestone: MilestoneDisplayData = this.createPlannedMilestone(milestone, groupPrefix + milestone.GanttTaskCategory.toLowerCase());

            //order matters
            if (actualWork != null) { chartHash.set("actualWork-" + this.getMilestoneName(milestone).toLowerCase(), actualWork); }
            //if (plannedWork != null) { chartHash.set("plannedWork-" + milestone.Name.toLowerCase(), plannedWork); }
            if (actualMilestone != null) { chartHash.set("actualDeliv-" + this.getMilestoneName(milestone).toLowerCase(), actualMilestone); }
            if (plannedMilestone != null) { chartHash.set("plannedDeliv-" + this.getMilestoneName(milestone).toLowerCase(), plannedMilestone); }
        }

        //to sort the hashed values
        let chartDataArray: MilestoneDisplayData[] = Array.from(chartHash.values());
        chartDataArray = chartDataArray.sort((a: MilestoneDisplayData, b: MilestoneDisplayData) => (a.sort < b.sort) ? -1 : 1);
        //console.log(chartDataArray);

        //push hidden data to end and beginning last so scroll sets to far left and not far right
        endSpacerData.start = maxDate + (30 * 24 * 60 * 60 * 1000); //30 days after latest event
        endSpacerData.end = endSpacerData.start;
        //chartHash.set("end-spacer", endSpacerData);
        maxDate = endSpacerData.end;

        startSpacerData.start = minDate - (30 * 24 * 60 * 60 * 1000); //30 days before earliest event
        startSpacerData.end = startSpacerData.start;
        //chartHash.set("start-spacer", startSpacerData);
        minDate = startSpacerData.start;

        chartDataArray.push(endSpacerData);
        chartDataArray.push(startSpacerData);
        //console.log(Array.from(chartHash.values()));
        //console.log(chartDataArray);

        // THE CHART
        Highcharts.ganttChart('gantt-chart', {
            credits: { enabled: false },
            chart: {
                styledMode: false,
            },
            xAxis: {
                min: minDate,
                max: maxDate,
                tickInterval: (24 * 3600 * 1000 * 30), //stay at month view
                currentDateIndicator: {
                    width: 3,
                    dashStyle: 'solid',
                    color: 'rgba(39,73,110)',
                    label: {
                        format: ''
                    }
                }
            },
            yAxis: {
                uniqueNames: true,
                staticScale: 30, //line height
                labels: {
                    style: {
                        width: '350px',
                        wordwrap: 'break-word',
                        fontSize: '12px',
                        textOverflow: 'ellipsis'
                    }
                }
            },
            tooltip: {
                headerFormat: '',
                dateTimeLabelFormats: {
                    hour: "%B %e, %Y",
                },
                useHtml: true,
                formatter: function () {
                    let tooltip: string = '<strong>' + this.key + '</strong><br><br>';

                    if (this.point.type == "planned") {
                        tooltip += '<i>Planned Completion:</i> ' + Highcharts.dateFormat('%b %d %Y', this.x2);
                    }
                    else {

                        if (this.x != this.x2) {
                            tooltip += '<br><i>Start:</i> ' + Highcharts.dateFormat('%b %d %Y', this.x);
                            if (this.point.type === "group") {
                                if (!completionMap.get(this.key)) {
                                    tooltip += '<br><i>In Progress</i> ';
                                }
                                else {
                                    tooltip += '<br><i>Completion:</i> ' + Highcharts.dateFormat('%b %d %Y', this.x2);
                                }
                            }
                            else {
                                let name = this.point.name;
                                if (name.includes("[")) {
                                    name = name.substring(0, name.indexOf("[")-1);
                                }
                                if (!taskCompletionMap.get(name)) {
                                    
                                    tooltip += '<br><i>Completed</i> ';
                                }
                                else {
                                    tooltip += '<br><i>In Progress</i> ';
                                }
                            }
                        }
                        else {
                            tooltip += '<br><i>Completion:</i> ' + Highcharts.dateFormat('%b %d %Y', this.x2);
                        }
                    }
                    return tooltip;

                    //+ 'Start: ' + Highcharts.dateFormat('%A, %b %d %Y', this.x) + '<br />' + 'Go live: ' + Highcharts.dateFormat('%A, %b %d %Y', this.x2)
                }
            },
            legend: { enabled: false },
            scrollbar: {
                enabled: true,
            },
            rangeSelector: {
                enabled: true,
                inputEnabled: false,
                selected: 3,
                buttonPosition: {
                    align: 'right'
                },
                buttons: [{
                    type: 'month',
                    count: 3,
                    text: '3m',
                    events: { click: (event) => { this.setZoom(7862400000); } }
                }, {
                    type: 'month',
                    count: 6,
                    text: '6m',
                    events: { click: (event) => { this.setZoom(15897600000); } }
                }, {
                    type: 'year',
                    count: 1,
                    text: '1y',
                    events: { click: (event) => { this.setZoom(31536000000); } }
                }, {
                    type: 'all',
                    text: 'All',
                    events: { click: (event) => { this.setZoom(-1); } }
                }]
            },

            series: [{ data: chartDataArray }]
            //series: [{ data: Array.from(chartHash.values()) }]

        }, (chart) => this.chart = chart);
    }

    today(): Date {
        let today: Date = new Date();

        // Set to 00:00:00:000 today
        today.setHours(24);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        return today;
    }

    createActualWork(milestone: Task, parent: string, today: Date): MilestoneDisplayData {

        let actual: MilestoneDisplayData = new MilestoneDisplayData(this.getMilestoneName(milestone), "actual", milestone.SortOrder + "-actualWork", parent, milestone.SortOrder, milestone.DependencyList, null);
        actual.checkDates(null, null, this.getDate(milestone.ActualStartDate), (milestone.Status == "Completed") ? this.getDate(milestone.ActualEndDate) : (milestone.Status == "In Progress") ? today : null);
        actual.setColorByStatus("Completed"); //or in progress - doesn't matter - just need the non-planning color
        actual.milestone = false;

        if (actual.start != null && actual.end != null && actual.start != actual.end) return actual;
        else return null;
    }

    createActualMilestone(milestone: Task, parent: string): MilestoneDisplayData {

        if (milestone.ActualEndDate != null && milestone.ActualEndDate != "") {
            let actual: MilestoneDisplayData = new MilestoneDisplayData(this.getMilestoneName(milestone), "actual", milestone.SortOrder + "actualMilestone", parent, milestone.SortOrder, milestone.DependencyList, null);
            actual.setDates(this.getDate(milestone.ActualEndDate).getTime(), this.getDate(milestone.ActualEndDate).getTime());
            actual.setColorByStatus("Completed"); //or in progress - doesn't matter - just need the non-planning color
            actual.milestone = true;
            return actual;
        }
        else return null;
    }

    //createPlannedWork(milestone: Task, parent: string): MilestoneDisplayData {
    //    let planned: MilestoneDisplayData = new MilestoneDisplayData(milestone.Name, "planned", null, parent, null);
    //    planned.checkDates(this.getDate(milestone.ActualStartDate), this.getDate(milestone.ActualEndDate), null, null);
    //    planned.setColorByStatus("Not Started");
    //    planned.milestone = false;

    //    if (planned.start != null && planned.end != null && planned.start != planned.end) return planned;
    //    else return null;
    //}

    createPlannedMilestone(milestone: Task, parent: string): MilestoneDisplayData {

        if (milestone.PlannedEndDate != null && milestone.PlannedEndDate != "") {

            let planned: MilestoneDisplayData = new MilestoneDisplayData(this.getMilestoneName(milestone), "planned", milestone.SortOrder + "-plannedMilestone", parent, milestone.SortOrder, milestone.DependencyList, null);
            planned.setDates(this.getDate(milestone.PlannedEndDate).getTime(), this.getDate(milestone.PlannedEndDate).getTime());
            planned.setColorByStatus("Not Started");
            planned.milestone = true;
            return planned;
        }
        else return null;
    }

    getMilestoneName(milestone: Task): string {
        if (milestone.VersionLabel && milestone.VersionLabel.length > 0) return milestone.Name + " [" + milestone.VersionLabel + "]";
        else return milestone.Name;
    }

    setZoom(delta: number): void {
        let start: number = this.chart.xAxis[0].dataMin;
        let end: number = (delta == -1) ? this.chart.xAxis[0].dataMax : start + delta

        this.chart.xAxis[0].setExtremes(start, end);
        this.chart.redraw();
    }

    getDate(dateString: string): Date {
        if (dateString == null || dateString == "") return null;

        let tempDate: Date = new Date(dateString);
        tempDate.setHours(12);
        tempDate.setMinutes(0);
        tempDate.setSeconds(0);
        tempDate.setMilliseconds(0);

        return tempDate;
    }

}

class MilestoneDisplayData {

    name: string = null;
    id: string = null;
    parent: string = null;
    dependency: string[] = null;
    start: number = null;
    end: number = null;
    sort: number = null;
    color: string = null;
    type: string = null;
    milestone: boolean = null;
    collapsed: boolean = null;
    pointWidth: number = 20; //default

    constructor(name: string, type: string, id: string, parent: string, sort: number, dependency: string[], collapsed: boolean) {
        this.name = name;
        this.type = type;
        this.id = id;
        this.parent = parent;
        this.sort = sort;
        this.dependency = dependency;
        this.collapsed = collapsed;
    }

    //once a milestone is made active, don't let it revert to scheduled
    setColorByStatus(status: string) {
        if (status == 'Completed' || status == 'In Progress') this.color = 'rgba(21,40,80)';
        else if (this.color == null) {
            this.color = 'rgba(255, 199, 87)';
            this.pointWidth = 10;
        }
    }

    setDates(start: number, end: number): void {
        this.start = start;
        this.end = end;
    }

    checkDates(plannedStart: Date, plannedEnd: Date, actualStart: Date, actualEnd: Date): void {
        this.checkDateBounds(plannedStart);
        this.checkDateBounds(plannedEnd);
        this.checkDateBounds(actualStart);
        this.checkDateBounds(actualEnd);
    }

    checkDateBounds(date: Date): void {
        if (date != null) {
            if (this.start == null) this.start = date.getTime();
            else if (date.getTime() < this.start) this.start = date.getTime();

            if (this.end == null) this.end = date.getTime();
            else if (date.getTime() > this.end) this.end = date.getTime();
        }
    }
}
